class STRING_UTILS {

  accentsMap = [
    'aàảãáạăằẳẵắặâầẩẫấậ',
    'AÀẢÃÁẠĂẰẲẴẮẶÂẦẨẪẤẬ',
    'dđ',
    'DĐ',
    'eèẻẽéẹêềểễếệ',
    'EÈẺẼÉẸÊỀỂỄẾỆ',
    'iìỉĩíị',
    'IÌỈĨÍỊ',
    'oòỏõóọôồổỗốộơờởỡớợ',
    'OÒỎÕÓỌÔỒỔỖỐỘƠỜỞỠỚỢ',
    'uùủũúụưừửữứự',
    'UÙỦŨÚỤƯỪỬỮỨỰ',
    'yỳỷỹýỵ',
    'YỲỶỸÝỴ',
  ]

  removeAccents(value) {
    for (let i = 0; i < this.accentsMap.length; i++) {
      const regex = new RegExp('[' + this.accentsMap[i].slice(1) + ']', 'g')
      const char = this.accentsMap[i][0]

      value = value.replace(regex, char)
    }
    return value
  }

  removeAcent(str, opt) {
    const AccentsMap = [
      'aàảãáạăằẳẵắặâầẩẫấậ',
      'AÀẢÃÁẠĂẰẲẴẮẶÂẦẨẪẤẬ',
      'dđ',
      'DĐ',
      'eèẻẽéẹêềểễếệ',
      'EÈẺẼÉẸÊỀỂỄẾỆ',
      'iìỉĩíị',
      'IÌỈĨÍỊ',
      'oòỏõóọôồổỗốộơờởỡớợ',
      'OÒỎÕÓỌÔỒỔỖỐỘƠỜỞỠỚỢ',
      'uùủũúụưừửữứự',
      'UÙỦŨÚỤƯỪỬỮỨỰ',
      'yỳỷỹýỵ',
      'YỲỶỸÝỴ',
    ]
    for (let i = 0; i < AccentsMap.length; i++) {
      const re = new RegExp('[' + AccentsMap[i].substring(1) + ']', 'g')
      const char = AccentsMap[i][0]
      str = str.replace(re, char)
    }
    return opt?.keepCapital ? str : str.toLowerCase()
  }
  isAccents(value) {
    for (let i = 0; i < this.accentsMap.length; i++) {
      const regex = new RegExp('[' + this.accentsMap[i].slice(1) + ']', 'g')
      const match = regex.test(value)
      if (match) return true
    }

    return false
  }
}

const StringUtils = new STRING_UTILS()

export default StringUtils
